<div class="space-y-6">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-2xl font-semibold text-gray-800">Promotions Management</h2>
      <p class="text-sm text-gray-500 mt-1">Create and manage discount codes.</p>
    </div>
    <div class="flex gap-3">
        <button
          (click)="loadPromotions()"
          class="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200 transition">
          Refresh
        </button>
        <button
          (click)="openCreateModal()"
          class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition">
          + Create Promotion
        </button>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && errorMessage" class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
    <span>{{ errorMessage }}</span>
    <button (click)="loadPromotions()" class="ml-auto text-sm underline">Retry</button>
  </div>

  <!-- Data Grid -->
  <div *ngIf="!isLoading && !errorMessage" class="bg-white rounded-2xl shadow overflow-hidden">
    <table class="w-full text-sm">
      <thead class="bg-gray-100 text-left">
        <tr>
          <th class="p-4">Code / Name</th>
          <th>Discount</th>
          <th>Usage</th>
          <th>Valid Until</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let promo of promotions" class="border-t hover:bg-gray-50">
          <td class="p-4">
             <p class="font-semibold text-gray-800 tracking-wide">{{ promo.code }}</p>
             <p class="text-xs text-gray-500 mt-1">{{ promo.name }}</p>
          </td>
          <td class="font-medium text-gray-800">
              {{ promo.type === 'percent' ? promo.value + '%' : '$' + promo.value }}
              <span *ngIf="promo.max_discount" class="text-xs text-gray-500 block font-normal">Max: ${{ promo.max_discount }}</span>
          </td>
          <td class="text-gray-600">
              {{ promo.used_count }} <span *ngIf="promo.usage_limit">/ {{ promo.usage_limit }}</span>
          </td>
          <td class="text-gray-600">
              {{ (promo.ends_at | date:'mediumDate') ?? 'No Expiry' }}
              <span *ngIf="isExpired(promo.ends_at)" class="text-red-500 block text-xs">Expired</span>
          </td>
          <td>
            <span [class]="promo.is_active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'" class="px-2 py-1 rounded-full text-xs font-medium border">
              {{ promo.is_active ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td>
             <div class="flex items-center gap-3 pr-4">
                <button (click)="openEditModal(promo)" class="text-blue-600 hover:underline">Edit</button>
                <button (click)="deletePromotion(promo.id)" class="text-red-600 hover:underline">Delete</button>
             </div>
          </td>
        </tr>
        <tr *ngIf="promotions.length === 0">
          <td colspan="6" class="p-8 text-center text-gray-500">No promotions available.</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>

<!-- Modal Form -->
<app-modal [isOpen]="isModalOpen" (close)="isModalOpen = false" className="max-w-2xl">
    <app-promotion-form 
        *ngIf="isModalOpen"
        [promotionData]="selectedPromotion" 
        (save)="handleSave($event)" 
        (cancel)="isModalOpen = false">
    </app-promotion-form>
</app-modal>
